"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignChannelToJSON = exports.CampaignChannelFromJSONTyped = exports.CampaignChannelFromJSON = exports.CampaignChannel = void 0;
/**
 * Channel to identify the booking flow which the campaign was created.
 * @export
 */
exports.CampaignChannel = {
    UNSET: 'UNSET',
    UNKNOWN: 'UNKNOWN',
    MANAGED: 'MANAGED',
    MEGAPHONE: 'MEGAPHONE',
    SELF_SERVE: 'SELF_SERVE',
    FORMATS_TEST: 'FORMATS_TEST'
};
function CampaignChannelFromJSON(json) {
    return CampaignChannelFromJSONTyped(json, false);
}
exports.CampaignChannelFromJSON = CampaignChannelFromJSON;
function CampaignChannelFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.CampaignChannelFromJSONTyped = CampaignChannelFromJSONTyped;
function CampaignChannelToJSON(value) {
    return value;
}
exports.CampaignChannelToJSON = CampaignChannelToJSON;
